import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainContainer from "../../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import IosSwitchMain from "../../../components/iosSwitchMain";
import SearchBar from "../../../components/SearchBar";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
function AddUserLink() {
  const navigate = useNavigate();
  const [type, setType] = useState("");
  const [type1, setType1] = useState("");
  const [isAdvanceBooking, setIsAdvanceBooking] = useState(false);
  const [isPartnerIncluded, setIsPartnerIncluded] = useState(false);
  const [isGuestIncluded, setIsGuestIncluded] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const offerType = queryParams.get("offerType");
  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value);
  };
  const handleTypeChange3 = (event: SelectChangeEvent) => {
    setType1(event.target.value);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const offerOptions = [
    "admin@yopmail.com",
    "john@yopmail.com",
    "adam@yopmail.com",
  ];

  const [value, setValue] = React.useState({
    page: "0",
    type: "0",
    type1: "0",
  });
  const goBack = () => {
    navigate(-1);
  };
  const handleChange1 = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const rows = [
    {
      name: "Madelyn Dias",
      avatar: "",
      email: "madelyn@gmail.com",
      amount: "AED 200",
      type: "Guest",
    },
    {
      name: "Madelyn Dias",
      avatar: "",
      email: "dias@gmail.com",
      amount: "AED 300",
      type: "User",
    },
    // more records...
  ];
  return (
    <MainContainer>
      <div className="main_title d_flex">
        <div className="left_s">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            Add User
          </h1>
        </div>
      </div>
      {offerType === "EVENT" ? (
        <div className="cards add_user_link">
          <div className="">
            <div className="control_group w_100">
              <label>Type</label>
              <FormControl className="paid_radio">
                <RadioGroup value={type} onChange={handleTypeChange}>
                  <FormControlLabel
                    value="Complimentary"
                    control={<Radio />}
                    label="Complimentary"
                  />
                  <FormControlLabel
                    value="Generate link"
                    control={<Radio />}
                    label="Send Invite"
                  />
                  <FormControlLabel
                    value="Paid"
                    control={<Radio />}
                    label="Paid"
                  />
                  <FormControlLabel
                    value="Create Booking"
                    control={<Radio />}
                    label="Create Booking"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            {/* Show this only when type is "Complimentary" */}
            {type === "Complimentary" && (
              <>
                <div className="gap_p">
                  <div className="control_group cncl_plcy w_50">
                    <label>Previous Event</label>
                    <IosSwitchMain
                      checked={isAdvanceBooking}
                      onChange={(e) => setIsAdvanceBooking(e.target.checked)}
                    />
                  </div>

                  {isAdvanceBooking && ( // ✅ Only show Select if switch is ON
                    <>
                      <div className="control_group w_50">
                        <Select
                          className="dropse"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          name="type"
                          value={value.type}
                          onChange={handleChange1}
                        >
                          <MenuItem value="0" disabled>
                            Select Offer
                          </MenuItem>
                          <MenuItem value="10">Offer 1</MenuItem>
                          <MenuItem value="20">Offer 2</MenuItem>
                        </Select>
                      </div>
                      <div className="table_header">
                        <div className="left_s">
                          <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..."
                          />
                        </div>
                      </div>
                      <div className="table_container">
                        <table
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead
                            style={{
                              backgroundColor: "#C19857",
                              color: "#fff",
                              textAlign: "left",
                            }}
                          >
                            <tr>
                              <th>
                                {" "}
                                <Checkbox />
                              </th>{" "}
                              {/* Checkbox */}
                              <th>Name</th>
                              <th>Type</th>
                            </tr>
                          </thead>
                          <tbody>
                            {rows.map((row, index) => (
                              <tr
                                key={index}
                                style={{
                                  color: "#fff",
                                  borderBottom: "1px solid #444",
                                }}
                              >
                                <td>
                                  <Checkbox />
                                </td>
                                <td
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <img
                                    src={
                                      row.avatar ||
                                      "/static/images/user_placeholder.png"
                                    }
                                    alt={row.name}
                                    style={{
                                      width: 32,
                                      height: 32,
                                      borderRadius: "50%",
                                    }}
                                  />
                                  {row.name}
                                </td>
                                <td>{row.type}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="mt_30">
                        <Button className="btn btn_primary">Add</Button>
                      </div>
                    </>
                  )}
                  {!isAdvanceBooking && (
                    <>
                      <div className="table_header">
                        <div className="left_s">
                          <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..."
                          />
                        </div>
                      </div>
                      <div className="table_container">
                        <table
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead
                            style={{
                              backgroundColor: "#C19857",
                              color: "#fff",
                              textAlign: "left",
                            }}
                          >
                            <tr>
                              <th>
                                {" "}
                                <Checkbox />
                              </th>{" "}
                              {/* Checkbox */}
                              <th>Name</th>
                              <th>Type</th>
                            </tr>
                          </thead>
                          <tbody>
                            {rows.map((row, index) => (
                              <tr
                                key={index}
                                style={{
                                  color: "#fff",
                                  borderBottom: "1px solid #444",
                                }}
                              >
                                <td>
                                  <Checkbox />
                                </td>
                                <td
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <img
                                    src={
                                      row.avatar ||
                                      "/static/images/user_placeholder.png"
                                    }
                                    alt={row.name}
                                    style={{
                                      width: 32,
                                      height: 32,
                                      borderRadius: "50%",
                                    }}
                                  />
                                  {row.name}
                                </td>
                                <td> {row.type}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="mt_30">
                        <Button className="btn btn_primary">Save</Button>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            {type === "Generate link" && (
              <>
                <div className="gap_p">
                  <div className="control_group w_50">
                    <Autocomplete
                      disablePortal
                      options={offerOptions}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Email Address"
                          hiddenLabel
                          {...params}
                        />
                      )}
                    />
                  </div>
                  <div className="control_group w_50">
                    <TextField
                      variant="outlined"
                      placeholder="Name"
                      fullWidth
                      hiddenLabel
                      // InputProps={{ readOnly: true }}
                    />
                  </div>
                  <div className="control_group w_50">
                    <TextField
                      variant="outlined"
                      placeholder="AED 1500"
                      fullWidth
                      hiddenLabel
                      // InputProps={{ readOnly: true }}
                    />
                  </div>
                  <div
                    className="control_group w_50"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button className="btn btn_primary">Add</Button>
                  </div>
                  {/* <div className="control_group cncl_plcy w_50">
                  <label>Payment </label>
                  <IosSwitchMain
                    checked={isPaymentCheck}
                    onChange={(e) => setisPaymentCheck(e.target.checked)}
                  />
                </div> */}
                  {/* {isPaymentCheck && (
                  <>
                    <div className="control_group w_50">
                      <TextField
                        variant="outlined"
                        placeholder="AED 1500"
                        fullWidth
                        hiddenLabel
                        // InputProps={{ readOnly: true }}
                      />
                    </div>
                  </>
                )} */}
                  <div className="table_container">
                    <table
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead
                        style={{
                          backgroundColor: "#C19857",
                          color: "#fff",
                          textAlign: "left",
                        }}
                      >
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row, index) => (
                          <tr
                            key={index}
                            style={{
                              color: "#fff",
                              borderBottom: "1px solid #444",
                            }}
                          >
                            <td
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <img
                                src={
                                  row.avatar ||
                                  "/static/images/user_placeholder.png"
                                }
                                alt={row.name}
                                style={{
                                  width: 32,
                                  height: 32,
                                  borderRadius: "50%",
                                }}
                              />
                              {row.name}
                            </td>
                            <td>{row.email}</td>
                            <td>{row.amount}</td>
                            <td>
                              {" "}
                              <IconButton>
                                <img
                                  src="/static/images/trash2_icon.svg"
                                  alt="Delete"
                                />
                              </IconButton>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="mt_30">
                    <Button className="btn btn_primary">Save</Button>
                  </div>
                </div>
              </>
            )}
            {type === "Paid" && (
              <>
                <div className="gap_p">
                  <div className="control_group cncl_plcy w_50">
                    <label>Previous Event</label>
                    <IosSwitchMain
                      checked={isAdvanceBooking}
                      onChange={(e) => setIsAdvanceBooking(e.target.checked)}
                    />
                  </div>
                  <div className="control_group cncl_plcy w_50">
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search..."
                    />
                  </div>

                  {isAdvanceBooking && ( // ✅ Only show Select if switch is ON
                    <>
                      <div className="control_group w_50">
                        <Select
                          className="dropse"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          name="type"
                          value={value.type}
                          onChange={handleChange1}
                        >
                          <MenuItem value="0" disabled>
                            Select Offer
                          </MenuItem>
                          <MenuItem value="10">Offer 1</MenuItem>
                          <MenuItem value="20">Offer 2</MenuItem>
                        </Select>
                      </div>
                      <div className="control_group w_100">
                        <label>Same amount for all</label>
                        <FormControl className="paid_radio">
                          <RadioGroup
                            value={type1}
                            onChange={handleTypeChange3}
                          >
                            <FormControlLabel
                              value="Yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                      {type1 === "Yes" && (
                        <>
                          <div className="control_group w_50">
                            <TextField
                              variant="outlined"
                              placeholder="Amount"
                              fullWidth
                              hiddenLabel
                            />
                          </div>
                          <div className="table_header">
                            <div className="left_s">
                              <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search..."
                              />
                            </div>
                          </div>
                          <div className="table_container">
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                              }}
                            >
                              <thead
                                style={{
                                  backgroundColor: "#C19857",
                                  color: "#fff",
                                  textAlign: "left",
                                }}
                              >
                                <tr>
                                  <th>
                                    {" "}
                                    <Checkbox />
                                  </th>{" "}
                                  {/* Checkbox */}
                                  <th>Name</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rows.map((row, index) => (
                                  <tr
                                    key={index}
                                    style={{
                                      color: "#fff",
                                      borderBottom: "1px solid #444",
                                    }}
                                  >
                                    <td>
                                      <Checkbox />
                                    </td>
                                    <td
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <img
                                        src={
                                          row.avatar ||
                                          "/static/images/user_placeholder.png"
                                        }
                                        alt={row.name}
                                        style={{
                                          width: 32,
                                          height: 32,
                                          borderRadius: "50%",
                                        }}
                                      />
                                      {row.name}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                      {type1 === "No" && (
                        <>
                          <div className="table_header">
                            <div className="left_s">
                              <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search..."
                              />
                            </div>
                          </div>
                          <div className="table_container">
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                              }}
                            >
                              <thead
                                style={{
                                  backgroundColor: "#C19857",
                                  color: "#fff",
                                  textAlign: "left",
                                }}
                              >
                                <tr>
                                  <th>
                                    {" "}
                                    <Checkbox />
                                  </th>
                                  <th>Name</th>

                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rows.map((row, index) => (
                                  <tr
                                    key={index}
                                    style={{
                                      color: "#fff",
                                      borderBottom: "1px solid #444",
                                    }}
                                  >
                                    <td>
                                      {" "}
                                      <Checkbox />
                                    </td>
                                    <td
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        borderBottom: "none",
                                      }}
                                    >
                                      <img
                                        src={
                                          row.avatar ||
                                          "/static/images/user_placeholder.png"
                                        }
                                        alt={row.name}
                                        style={{
                                          width: 32,
                                          height: 32,
                                          borderRadius: "50%",
                                        }}
                                      />
                                      {row.name}
                                    </td>

                                    <td>
                                      {" "}
                                      <div className="control_group">
                                        <TextField
                                          variant="outlined"
                                          placeholder="Amount"
                                          fullWidth
                                          hiddenLabel
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                      {/* <div className="mt_30">
                      <Button className="btn btn_primary">Add</Button>
                    </div> */}
                    </>
                  )}
                  {!isAdvanceBooking && (
                    <>
                      <div className="control_group w_100">
                        <label>Same amount for all</label>
                        <FormControl className="paid_radio">
                          <RadioGroup
                            value={type1}
                            onChange={handleTypeChange3}
                          >
                            <FormControlLabel
                              value="Yes"
                              control={<Radio />}
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>

                      {type1 === "Yes" && (
                        <>
                          <div className="control_group w_50">
                            <TextField
                              variant="outlined"
                              placeholder="Amount"
                              fullWidth
                              hiddenLabel
                            />
                          </div>

                          <div className="table_header">
                            <div className="left_s">
                              <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search..."
                              />
                            </div>
                          </div>

                          <div className="table_container">
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                              }}
                            >
                              <thead
                                style={{
                                  backgroundColor: "#C19857",
                                  color: "#fff",
                                  textAlign: "left",
                                }}
                              >
                                <tr>
                                  <th>
                                    {" "}
                                    <Checkbox />
                                  </th>
                                  <th>Name</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rows.map((row, index) => (
                                  <tr
                                    key={index}
                                    style={{
                                      borderBottom: "1px solid #444",
                                      color: "#fff",
                                    }}
                                  >
                                    <td>
                                      <Checkbox />
                                    </td>
                                    <td
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <img
                                        src={
                                          row.avatar ||
                                          "/static/images/user_placeholder.png"
                                        }
                                        alt={row.name}
                                        style={{
                                          width: 32,
                                          height: 32,
                                          borderRadius: "50%",
                                        }}
                                      />
                                      {row.name}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}

                      {type1 === "No" && (
                        <>
                          <div className="table_header">
                            <div className="left_s">
                              <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search..."
                              />
                            </div>
                          </div>

                          <div className="table_container">
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                              }}
                            >
                              <thead
                                style={{
                                  backgroundColor: "#C19857",
                                  color: "#fff",
                                  textAlign: "left",
                                }}
                              >
                                <tr>
                                  <th>
                                    {" "}
                                    <Checkbox />
                                  </th>
                                  <th>Name</th>

                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rows.map((row, index) => (
                                  <tr
                                    key={index}
                                    style={{
                                      borderBottom: "1px solid #444",
                                      color: "#fff",
                                    }}
                                  >
                                    <td>
                                      {" "}
                                      <Checkbox />
                                    </td>
                                    <td
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        borderBottom: "none",
                                      }}
                                    >
                                      <img
                                        src={
                                          row.avatar ||
                                          "/static/images/user_placeholder.png"
                                        }
                                        alt={row.name}
                                        style={{
                                          width: 32,
                                          height: 32,
                                          borderRadius: "50%",
                                        }}
                                      />
                                      {row.name}
                                    </td>

                                    <td>
                                      <div className="control_group">
                                        <TextField
                                          variant="outlined"
                                          placeholder="Amount"
                                          fullWidth
                                          hiddenLabel
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
                <div className="mt_30">
                  <Button className="btn btn_primary">Save</Button>
                </div>
              </>
            )}
            {type === "Create Booking" && (
              <div className="gap_p">
                <div className="control_group w_33">
                  <Autocomplete
                    disablePortal
                    options={offerOptions}
                    sx={{ width: 300 }}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Email Address"
                        hiddenLabel
                        {...params}
                      />
                    )}
                  />
                </div>
                <div className="control_group w_33">
                  <TextField
                    variant="outlined"
                    placeholder="Name"
                    fullWidth
                    hiddenLabel
                    // InputProps={{ readOnly: true }}
                  />
                </div>
                <div className="control_group w_33">
                  <TextField
                    variant="outlined"
                    placeholder="Dietary Requirement"
                    fullWidth
                    hiddenLabel
                    // InputProps={{ readOnly: true }}
                  />
                </div>

                <div className="control_group cncl_plcy w_50">
                  <label>Include Partner</label>
                  <IosSwitchMain
                    checked={isPartnerIncluded}
                    onChange={(e) => setIsPartnerIncluded(e.target.checked)}
                  />
                </div>
                {isPartnerIncluded && (
                  <>
                    <div className="gap_p">
                      <div className="control_group w_33">
                        <TextField
                          variant="outlined"
                          placeholder="Email"
                          fullWidth
                          hiddenLabel
                        />
                      </div>
                      <div className="control_group w_33">
                        <TextField
                          variant="outlined"
                          placeholder="Name"
                          fullWidth
                          hiddenLabel
                        />
                      </div>
                      <div className="control_group w_33">
                        <TextField
                          variant="outlined"
                          placeholder="Dietary Requirement"
                          fullWidth
                          hiddenLabel
                        />
                      </div>
                      <div className="control_group w_33">
                        <Select
                          className="dropse"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          name="type"
                          value={value.type}
                          onChange={handleChange1}
                        >
                          <MenuItem value="0" disabled>
                            Select Payar
                          </MenuItem>
                          <MenuItem value="10">Samantha</MenuItem>
                          <MenuItem value="20">John</MenuItem>
                        </Select>
                      </div>
                      <div className="control_group w_33">
                        <TextField
                          variant="outlined"
                          placeholder="Any special request or occasion?"
                          fullWidth
                          hiddenLabel
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className="control_group cncl_plcy w_50">
                  <label>Include Guest</label>
                  <IosSwitchMain
                    checked={isGuestIncluded}
                    onChange={(e) => setIsGuestIncluded(e.target.checked)}
                  />
                </div>
                {isGuestIncluded && (
                  <>
                    <div className="gap_p">
                      <div className="control_group w_33">
                        <TextField
                          variant="outlined"
                          placeholder="Email"
                          fullWidth
                          hiddenLabel
                        />
                      </div>
                      <div className="control_group w_33">
                        <TextField
                          variant="outlined"
                          placeholder="Name"
                          fullWidth
                          hiddenLabel
                        />
                      </div>
                      <div className="control_group w_33">
                        <TextField
                          variant="outlined"
                          placeholder="Dietary Requirement"
                          fullWidth
                          hiddenLabel
                        />
                      </div>
                      <div className="control_group w_50">
                        <Select
                          className="dropse"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          name="type"
                          value={value.type}
                          onChange={handleChange1}
                        >
                          <MenuItem value="0" disabled>
                            Select Payar
                          </MenuItem>
                          <MenuItem value="10">Samantha</MenuItem>
                          <MenuItem value="20">John</MenuItem>
                          <MenuItem value="20">Guest</MenuItem>
                        </Select>
                      </div>
                      <div
                        className="control_group w_50"
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button className="btn btn_primary">
                          Add More Guest
                        </Button>
                      </div>
                    </div>
                  </>
                )}
                <div className="mt_30">
                  <Button className="btn btn_primary">Save</Button>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="cards add_user_link">
          <div className="gap_p">
            <div className="control_group w_33">
              <Autocomplete
                disablePortal
                options={offerOptions}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    placeholder="Email Address"
                    hiddenLabel
                    {...params}
                  />
                )}
              />
            </div>
            <div className="control_group w_33">
              <TextField
                variant="outlined"
                placeholder="Name"
                fullWidth
                hiddenLabel
                // InputProps={{ readOnly: true }}
              />
            </div>
            <div className="control_group w_33">
              <TextField
                variant="outlined"
                placeholder="Dietary Requirement"
                fullWidth
                hiddenLabel
                // InputProps={{ readOnly: true }}
              />
            </div>
            <div className="control_group w_33">
              <TextField
                variant="outlined"
                placeholder="No. of Guests"
                fullWidth
                hiddenLabel
                // InputProps={{ readOnly: true }}
              />
            </div>

            <div className="w_33 control_group">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/calendar_icon.svg" alt="icon" />
                    ),
                    textField: (params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Select Date"
                        hiddenLabel
                      />
                    ),
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>

            <div className="control_group w_33">
              <TextField
                variant="outlined"
                placeholder="Time"
                fullWidth
                hiddenLabel
                // InputProps={{ readOnly: true }}
              />
            </div>

            <div className="control_group w_100 prfrnc">
              <label>Seating preferences </label>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Indoor Seating"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Outdoor Seating"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Indoor Seating"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Outdoor Seating"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Outdoor Seating"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Outdoor Seating"
                />
              </FormGroup>
            </div>
            <div className="control_group w_100 prfrnc">
              <label>Do you comply with cancellation policy? </label>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Cancellation Policy"
                />
              </FormGroup>
            </div>
          </div>
          <div className="mt_30">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      )}
    </MainContainer>
  );
}
export default AddUserLink;
